import { ApiLandingPagePlaylist } from '@storefronts/common-types'
import { ViddyCoreContext } from '../../context/viddyCoreContext'
import { useViddyCoreContextSetup } from '../../hooks/useViddyCoreAndVideoContextSetup'

export const CoreProvider: React.FC<{
    playlist: ApiLandingPagePlaylist | null
    children: React.ReactNode
}> = ({ playlist, children }) => {
    const coreStore = useViddyCoreContextSetup(playlist)
    return (
        <ViddyCoreContext.Provider value={coreStore}>
            {children}
        </ViddyCoreContext.Provider>
    )
}
